import styled from "styled-components"
import {
  StyledListGroup,
  StyledListTitle,
} from "../../s22_list/partials/StyledList"
import { StyledIcon, StyledTitle } from "./StyledAttr"

export interface StyledCardProps {
  border_accent?: string
  background_image?: string
  background_image_asset?: string
  background_image_asset_mobile?: string
  linked?: boolean
  hover?: boolean
  shadow?: boolean
}
export interface StyledCardInnerProps {
  shadow?: boolean
  background_color?: string
}
export interface StyledCardContentProps {
  background_color?: string
  is_alone?: boolean
  linked?: boolean
}
export interface StyledCardButtonsProps {
  button_position?: string
  is_alone?: boolean
  single_button?: boolean
  background_color?: string
}
export interface StyledCardListProps {
  is_alone?: boolean
}
export interface StyledCardFormProps {
  is_alone?: boolean
}

export interface StyledProgramCategory {
  program_category?: string
  header_image?: string
  attribute_color?: string
}

export const StyledCard = styled.div<StyledCardProps>`
  ${(props) =>
    props.background_image &&
    `
      background-image: url(${props.background_image});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    `}

  ${(props) => props.background_image_asset && `
          background-image: url(${props.background_image_asset});
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        `}

    ${(props) => props.background_image_asset_mobile && `
    @media (max-width: ${props.theme.breakPoints.tablet}) {
        background-image: url(${props.background_image_asset_mobile});
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }
    `}



  display: flex;
  flex-direction: column;
  position: relative;

  ${(props) =>
    props.linked &&
    `
      cursor: pointer; 
    `}
  ${(props) =>
    props.border_accent === "outline" &&
    `
        border: 1px solid ${props.theme.colors.darkGrey};
    `}
    ${(props) =>
    props.border_accent === "outline-white" &&
    `
          border: 1px solid ${props.theme.colors.white};
      `}
  ${(props) =>
    props.border_accent === "bba" &&
    `
        border-top: 6px solid ${props.theme.colors.undergraduate};
    `}
    ${(props) =>
    props.border_accent === "mba" &&
    `
        border-top: 6px solid ${props.theme.colors.mba};
    `}
    ${(props) =>
    props.border_accent === "doctorate" &&
    `
        border-top: 6px solid ${props.theme.colors.doctorate};
    `}
    ${(props) =>
    props.border_accent === "ashridge" &&
    `
        border-top: 6px solid ${props.theme.colors.executive};
    `}
    ${(props) =>
    props.border_accent === "masters" &&
    `
        border-top: 6px solid ${props.theme.colors.masters};
    `}
    ${(props) =>
    props.border_accent === "charcoal" &&
    `
        border-top: 6px solid ${props.theme.colors.darkGrey};
    `}

${(props) =>
    props.linked &&
    !props.hover &&
    `
    ${props.theme.mixins.hoverTransition}
    &:hover{
      ${props.theme.mixins.hover}
    }
    `}

${(props) => props.shadow &&
    `
    &:hover{
      box-shadow: none;
    }
    `}
`
export const StyledCardLink = styled.div`
  & a {
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    color: transparent;
  }
`
export const StyledCardImage = styled.div`
  margin: 0;
  display: flex;
  max-width: 100%;

  & > div {
    width: 100%;
  }
`
export const StyledCardInner = styled.div<StyledCardInnerProps>`
  width: 100%;
  box-shadow: ${(props) => !props.shadow && `0 0 16px ${props.theme.colors.darkGrey10};`};
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  ${(props) =>
    props.background_color === "no-background" &&
    `
    box-shadow: none;
    `}
  ${(props) =>
    props.background_color === "transparent-white" &&
    `
    box-shadow: none;
    `}
      ${(props) =>
    props.background_color === "transparent-charcoal" &&
    `
    box-shadow: none;
    `}

    ${StyledListTitle} {
    ${(props) =>
      props.background_color === "charcoal" &&
      `
      color: white;
      border-color: white;
    `}
  }

  ${StyledListGroup} {
    & li {
      ${(props) =>
        props.background_color === "charcoal" &&
        `
          border-bottom: 1px solid ${props.theme.colors.white20};
          color: ${props.theme.colors.white};

          & p{
              color: ${props.theme.colors.white};
          }

          &:nth-of-type(1){
              border-top: 1px solid ${props.theme.colors.white20};
          }
      `}
    }
  }

  ${StyledTitle} {
    ${(props) =>
      props.background_color === "charcoal" &&
      `
      color: white;
    `}
  }

  ${StyledIcon} {
    svg {
      ${(props) =>
        props.background_color === "charcoal" &&
        `
        color: white;
      `}
    }
  }
`

export const StyledCardContent = styled.div<StyledCardContentProps>`
  padding: 32px;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
  }
  ${(props) =>
    props.background_color === "white" &&
    `
      background-color: ${props.theme.colors.white};
    `}
  ${(props) =>
    props.background_color === "ivory" &&
    `
      background-color: ${props.theme.colors.ivory};
    `}
    ${(props) =>
    props.background_color === "ivory-dark" &&
    `
      background-color: ${props.theme.colors.ivoryShadow};
    `}
    ${(props) =>
    props.background_color === "charcoal" &&
    `
      background-color: ${props.theme.colors.darkGrey};
    `}
    ${(props) =>
    props.background_color === "no-background" &&
    `
      background-color: transparent;
      padding: 0;
      @media (max-width: ${props.theme.breakPoints.tablet}) {
        padding: 0;
      }
      @media (max-width: ${props.theme.breakPoints.mobile}) {
        padding: 0;
      }
    `}
    ${(props) =>
    props.background_color === "transparent-white" &&
    `
       background-color: transparent;
    `}
    ${(props) =>
    props.background_color === "transparent-charcoal" &&
    `
      background-color: transparent;
    `}
`
export const StyledCardLogo = styled.div`
  margin: 0 0 16px;
  display: flex;

  & img {
    max-height: 50px;
    height: 50px;
    width: auto !important;
  }
`

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  `

export const StyledCardLabel = styled.p<StyledCardContentProps>`
  ${(props) => props.theme.mixins.label};
  ${(props) =>
    props.background_color === "charcoal" &&
    `
      color: ${props.theme.colors.white80true};
    `}
  ${(props) =>
    props.background_color === "transparent-white" &&
    `
      color: ${props.theme.colors.white80true};
    `}
`
export const StyledCardTitle = styled.p<StyledCardContentProps>`
  ${(props) => props.theme.mixins.subsectionTitle};
  ${(props) =>
    props.background_color === "charcoal" &&
    `
      color: ${props.theme.colors.white};
    `}
  ${(props) =>
    props.background_color === "transparent-white" &&
    `
      color: ${props.theme.colors.white};
    `}
  & a {
    ${(props) => props.theme.mixins.subsectionTitle};
    color: inherit;

    &:before {
      content: "";
      width: 100%;
      height: 100%;
      cursor: pointer;
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      color: transparent;
    }
  }
`
export const StyledCardDescription = styled.div<StyledCardContentProps>`
  ${(props) =>
    props.background_color === "charcoal" ||
    props.background_color === "transparent-white"
      ? `
    ${props.theme.mixins.markdownAlt};
  `
      : `
    ${props.theme.mixins.markdown};
  `}
  ${(props) =>
    !props.is_alone &&
    `
    margin: 16px 0 0;
    `}
`
export const StyledCardList = styled.div<StyledCardListProps>`
  ${(props) =>
    !props.is_alone &&
    `
    margin: 16px 0 0;
    `}
`
export const StyledCardForm = styled.div<StyledCardFormProps>`
  ${(props) =>
    !props.is_alone &&
    `
    margin: 16px 0 0;
    `}
`
export const StyledCardButtons = styled.div<StyledCardButtonsProps>`
  display: flex;
  flex-wrap: wrap;
  ${(props) =>
    props.button_position === "left" &&
    `
        justify-content: flex-start;
    `}
  ${(props) =>
    props.button_position === "right" &&
    `
        justify-content: flex-end;
    `}
    ${(props) =>
    props.button_position === "full" &&
    `
        width: 100%;

        & a, & button{
            width: 100%;
        }
    `}

    & .button-v2--text, & .button-v2--text-alt {
    padding-top: 0;
    padding-bottom: 0;
    min-height: 0;

    ${(props) =>
      props.background_color === "charcoal" &&
      `
      color: ${props.theme.colors.white};
    `}
  }

  ${(props) =>
    !props.is_alone &&
    `
    padding-top: 24px;
    margin: -16px 0 0; 
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      margin: -12px 0 0; 
    }
    & > div,
    & > a,
    & > button {
      margin: 16px 16px 0 0;
      @media (max-width: ${props.theme.breakPoints.tablet}) {
        margin: 12px 12px 0 0;
      }
    }
  `}
  ${(props) =>
    props.single_button &&
    `
    margin: 0;
    & > div,
    & > a,
    & > button {
      margin: 0;
      @media (max-width: ${props.theme.breakPoints.tablet}) {
        margin: 0;
      }
    }
  `}
`

export const StyledProgramHeader = styled.div<StyledProgramCategory>`
  ${(props) =>
    props.program_category === "undergraduate" &&
    `background-color: ${props.theme.colors.undergraduate}; `}
  ${(props) =>
    props.program_category === "masters" &&
    `background-color: ${props.theme.colors.masters};`}
  ${(props) =>
    props.program_category === "mba" &&
    `background-color: ${props.theme.colors.mba};`}
  ${(props) =>
    props.program_category === "doctorate" &&
    `background-color: ${props.theme.colors.doctorate};`}
  ${(props) =>
    props.program_category === "executive" &&
    `background-color: ${props.theme.colors.executive};`}
  ${(props) => props.program_category && `padding: 16px 24px;`}

  ${(props) =>
    props.header_image &&
    `
      background-image: url(${props.header_image});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      padding: 16px 24px;
    `}
`

export const StyledProgramHeading = styled.div`
  ${(props) => props.theme.mixins.body};
  color: ${(props) => props.theme.colors.white};
`

export const StyledCardAttribute = styled.div<StyledProgramCategory>`
  padding-top: 24px;
  ${(props) => props.theme.mixins.body}
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.colors.darkGrey};
  ${(props) =>
    props.attribute_color === "charcoal" &&
    `color: ${props.theme.colors.darkGrey};`}
  ${(props) =>
    props.attribute_color === "white" && `color: ${props.theme.colors.white};`}

  & ${StyledIcon} {
    & svg {
      ${(props) =>
        props.program_category === "undergraduate" &&
        `color: ${props.theme.colors.undergraduate};`}
      ${(props) =>
        props.program_category === "masters" &&
        `color: ${props.theme.colors.masters};`}
      ${(props) =>
        props.program_category === "mba" && `color: ${props.theme.colors.mba};`}
      ${(props) =>
        props.program_category === "doctorate" &&
        `color: ${props.theme.colors.doctorate};`}
      ${(props) =>
        props.program_category === "executive" &&
        `color: ${props.theme.colors.executive};`}
    }
  }
`

export const StyledIconWrapper = styled.div<StyledProgramCategory>`
  margin-right: 16px;
`
